import { Routes } from '@angular/router';
import { UserRouteAccessService } from '../shared/auth/user-route-access-service';
import { SiteAdminComponent } from './site-admin.component';
import { RoleEditPopupComponent } from './tabs/roles/role-edit-dialog.component';
import { UsersPaneComponent } from './tabs/users/users-pane.component';
import { RolesPaneComponent } from './tabs/roles/roles-pane.component';
import { UserEditPopupComponent } from './tabs/users/user-edit-dialog.component';
import { UserRolePopupComponent } from './tabs/users/users-role-dialog.component';
import { OauthClientsPaneComponent } from './tabs/oauth-clients/oauth-clients/oauth-clients-pane.component';

export const SITE_ADMIN_ROUTES: Routes = [
    {
        path: 'site-admin',
        component: SiteAdminComponent,
        data: {
            pageTitle: 'site-admin.title',
            authorities: ['ADMIN', 'ADMINISTRATION', 'SITE_ADMIN']
        },
        canActivate: [UserRouteAccessService],
        children: [
            {
                path: '',
                redirectTo: 'users',
                pathMatch: 'full'
            },
            {
                path: 'users',
                component: UsersPaneComponent,
                data: {
                    pageTitle: 'site-admin.tabs.users'
                }
            },
            {
                path: 'roles',
                component: RolesPaneComponent,
                data: {
                    pageTitle: 'site-admin.tabs.roles'
                }
            },
            {
                path: 'oauth-clients',
                component: OauthClientsPaneComponent,
                data: {
                    pageTitle: 'site-admin.tabs.oauth-clients'
                }
            }
        ]
    },
    {
        path: 'role-edit-dialog',
        component: RoleEditPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'user-edit-dialog',
        component: UserEditPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'user-role-dialog',
        component: UserRolePopupComponent,
        outlet: 'popup'
    },
];
